<div class="modal fade" #modalElement tabindex="-1" [attr.aria-labelledby]="tituloId" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [id]="tituloId">{{ titulo }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div>
          <p [innerHTML]="descricao"></p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onNao()">{{ descricaoButtonFechar }}</button>
        <button *ngIf="showCancelar" type="button" class="btn btn-secondary" (click)="onCancelar()"><i class='bx bx-x me-1'></i>{{ descricaoButtonCancelar }} </button>
        <button type="button" class="btn btn-success" (click)="onSim()">{{ descricaoButtonSim }}</button>
      </div>
    </div>
  </div>
</div>